import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import termLifeReducer from './slices/termLifeSlice';
import dreamGoalReducer from './slices/dreamGoalSlice';
import addOnsReducer from './slices/addOnsSlice';
import userReducer from './slices/userSlice';
import rewardsHubReducer from './slices/RewardsHubSlice';
import mukamalSehatReducer from './slices/mukamalSehatSlice';
import { loggerMiddleware } from './middleware/loggerMiddleware';
import { errorMiddleware } from './middleware/errorMiddleware';
import { devToolsConfig } from './devtools';
// Enhanced store configuration with better error handling
export const store = configureStore({
  reducer: {
    auth: authReducer,
    subscription: subscriptionReducer,
    termLife: termLifeReducer,
    dreamGoal: dreamGoalReducer,
    addOns: addOnsReducer,
    user: userReducer,
    rewardsHub: rewardsHubReducer,
    mukamalSehat: mukamalSehatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serialization checks
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.timestamp', 'meta.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: [
          'subscription.lastUpdated',
          // Mukamal Sehat — Base64 image objects stored as plain { name, base64, type }
          // are serialisable strings but can be large; suppress the size warning.
          'mukamalSehat.members.self.cnicFrontImage',
          'mukamalSehat.members.self.cnicBackImage',
          'mukamalSehat.members.spouse.cnicFrontImage',
          'mukamalSehat.members.spouse.cnicBackImage',
          'mukamalSehat.members.father.cnicFrontImage',
          'mukamalSehat.members.father.cnicBackImage',
          'mukamalSehat.members.mother.cnicFrontImage',
          'mukamalSehat.members.mother.cnicBackImage',
        ],
      },
    })
      .concat(errorMiddleware)
      .concat(import.meta.env.VITE_NODE_ENV !== 'production' ? loggerMiddleware : []),
  devTools: import.meta.env.VITE_NODE_ENV !== 'production' ? devToolsConfig : false,
});

// Enhanced store with better error handling and logging
if (import.meta.env.VITE_NODE_ENV !== 'production') {
  store.subscribe(() => {
    const state = store.getState();
    console.log('Redux State Update:', {
      auth: {
        isAuthenticated: state.auth.isAuthenticated,
        hasUser: !!state.auth.user,
        loading: state.auth.loading
      },
      subscription: {
        hasData: !!state.subscription.subscriptionData,
        isActive: state.subscription.isActive,
        isPersisted: state.subscription.isPersisted
      }
    });
  });
}

export default store;
